/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { LegacyDataTable, LegacyDataTableBody, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { CertificateResource, Certificate } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import ThumbprintText from "~/components/ThumbprintText";
import DateFormatter from "~/utils/DateFormatter";
interface BasicCertificateDisplayProps {
    certificate: Certificate;
}
const BasicCertificateDisplay = (props: BasicCertificateDisplayProps) => {
    return (<React.Fragment>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Subject</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.SubjectDistinguishedName}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Issuer</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.IssuerDistinguishedName}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Not After</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>
                    {DateFormatter.dateToLongFormat(props.certificate.NotAfter)}
                    {props.certificate.IsExpired && <span> expired</span>}
                </LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Not Before</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{DateFormatter.dateToLongFormat(props.certificate.NotBefore)}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Thumbprint</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>
                    <ThumbprintText thumbprint={props.certificate.Thumbprint!}/>
                </LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Version</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.Version}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Serial Number</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.SerialNumber}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Signature Algorithm</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.SignatureAlgorithmName}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
        </React.Fragment>);
};
interface DetailedCertificateDisplay {
    certificate: CertificateResource;
}
const DetailedCertificateDisplay = (props: DetailedCertificateDisplay) => {
    return (<React.Fragment>
            {props.certificate.Archived && (<LegacyDataTableRow>
                    <LegacyDataTableRowColumn>Archived</LegacyDataTableRowColumn>
                    <LegacyDataTableRowColumn>Archived on {props.certificate.Archived}</LegacyDataTableRowColumn>
                </LegacyDataTableRow>)}
            <LegacyDataTableRow>
                <LegacyDataTableRowColumn>Has Private Key</LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn>{props.certificate.HasPrivateKey ? "Yes" : "No"}</LegacyDataTableRowColumn>
            </LegacyDataTableRow>
            <BasicCertificateDisplay certificate={props.certificate}/>
            {props.certificate.SubjectAlternativeNames && props.certificate.SubjectAlternativeNames.length > 0 && (<LegacyDataTableRow>
                    <LegacyDataTableRowColumn>Subject Alternative Names</LegacyDataTableRowColumn>
                    <LegacyDataTableRowColumn>
                        {props.certificate.SubjectAlternativeNames.map((san: string) => (<>
                                <span>{san}</span>
                                <br />
                            </>))}
                    </LegacyDataTableRowColumn>
                </LegacyDataTableRow>)}
        </React.Fragment>);
};
interface CertificateDetailProps {
    certificate: CertificateResource | Certificate; //CertificateResource or X509Certificate
}
function isCertificateResource(cert: CertificateResource | Certificate): cert is CertificateResource {
    const converted = cert as CertificateResource;
    return converted.CertificateData !== undefined && converted.CertificateData.HasValue;
}
const CertificateDetail = (props: CertificateDetailProps) => {
    const Display = isCertificateResource(props.certificate) ? DetailedCertificateDisplay : BasicCertificateDisplay;
    return (<LegacyDataTable>
            <LegacyDataTableBody>
                <Display certificate={props.certificate as CertificateResource}/>
            </LegacyDataTableBody>
        </LegacyDataTable>);
};
export default CertificateDetail;
